<!-- Navbar Section -->
<nav class="navbar navbar-light bg-light app-header border-bottom sticky-top">
  <div class="container d-flex justify-content-between align-items-center">
    <!-- Brand/Logo -->
    <a href="https://gooddogkh.com" target="_blank" rel="noopener" class="navbar-brand">
      <img
        src="assets/img/brand/coco-pet-resort-long.png"
        class="img-fluid"
        style="max-height: 45px; width: auto;"
        title="CoCo Pet Logo"
      />
    </a>

    <!-- Language Flags -->
    <ul class="navbar-nav flex-row align-items-center">
      <li *ngFor="let language of supportedLanguages" class="nav-item ms-2">
        <a class="nav-link p-0" (click)="changeLanguage(language)" style="cursor: pointer;">
          <img
            src="assets/img/flags/4x3/{{language}}.svg"
            alt="Flag"
            style="width: 25px; height: auto;"
            class="shadow-sm rounded-sm"
          />
        </a>
      </li>
    </ul>
  </div>
</nav>

<!-- Main Form Content -->
<div class="bg-light min-vh-100 py-3 py-md-5">
  <c-container>
    <c-row class="justify-content-center">
      <!-- Responsive Column Widths -->
      <c-col xs="12" lg="10" xl="9">

        <c-card class="shadow-sm border-0">
          <c-card-body class="p-3 p-md-4">

            <form cForm [formGroup]="petRegisterForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

              <!-- Header -->
              <div class="mb-4">
                <h1 class="h3 fw-bold text-primary">{{ "REGISTRATION" | translate }}</h1>
                <p class="text-medium-emphasis">{{ "REGISTER_YOUR_PET" | translate }}</p>
              </div>

              <!-- 1. Branch Selection Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold">{{ "BRANCH" | translate }}</c-card-header>
                <c-card-body>
                  <c-row>
                    <c-col md="6" class="mb-3">
                      <label cLabel for="branchName">{{ "BRANCH_NAME" | translate }}</label>
                      <select cSelect formControlName="branchName" id="branchName">
                        <option *ngFor="let branch of branchesList" [ngValue]="branch">{{branch.name}}</option>
                      </select>
                    </c-col>
                    <c-col md="6">
                      <!-- Conditional Branch Info -->
                      <div class="p-3 bg-light rounded small" *ngIf="selectedBranch">
                        <p class="mb-1"><strong>Address:</strong> {{selectedBranch.address}}</p>
                        <p class="mb-0"><strong>Phone:</strong> {{selectedBranch.phone}}</p>
                      </div>
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>

              <!-- 2. Owner Information Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold">{{ "OWNER_INFORMATION" | translate }}</c-card-header>
                <c-card-body>
                  <!-- Name Row -->
                  <c-row class="mb-3">
                    <c-col md="6" class="mb-3 mb-md-0">
                      <label cLabel for="ownerFirstName">{{ "FIRST_NAME" | translate }}</label>
                      <input cFormControl formControlName="ownerFirstName" id="ownerFirstName" type="text" />
                    </c-col>
                    <c-col md="6">
                      <label cLabel for="ownerLastName">{{ "LAST_NAME" | translate }}</label>
                      <input cFormControl formControlName="ownerLastName" id="ownerLastName" type="text" />
                    </c-col>
                  </c-row>

                  <!-- Contact Row -->
                  <c-row class="mb-3">
                    <c-col md="6" class="mb-3 mb-md-0">
                      <label cLabel for="ownerPhone">{{ "PHONE" | translate }}</label>
                      <input cFormControl formControlName="ownerPhone" id="ownerPhone" type="text" />
                    </c-col>
                    <c-col md="6">
                      <label cLabel for="ownerEmail">{{ "EMAIL" | translate }}</label>
                      <input cFormControl formControlName="ownerEmail" id="ownerEmail" type="email" />
                    </c-col>
                  </c-row>

                  <!-- Address & Emergency -->
                  <c-row class="mb-3">
                    <c-col xs="12" class="mb-3">
                      <label cLabel for="ownerAddress">{{ "ADDRESS" | translate }}</label>
                      <input cFormControl formControlName="ownerAddress" id="ownerAddress" type="text" />
                    </c-col>
                    <c-col md="6" class="mb-3">
                      <label cLabel for="ownerNationality">{{ "NATIONALITY" | translate }}</label>
                      <input cFormControl formControlName="ownerNationality" id="ownerNationality" [typeahead]="nationalityList" typeaheadOptionField="name" />
                    </c-col>
                    <c-col md="6" class="mb-3">
                      <label cLabel for="ownerEmergencyContact">{{ "EMERGENCY_CONTACT" | translate }}</label>
                      <input cFormControl formControlName="ownerEmergencyContact" id="ownerEmergencyContact" />
                    </c-col>
                    <c-col xs="12">
                      <label cLabel for="ownerVetDetails">{{ "VET_DETAILS" | translate }}</label>
                      <textarea cFormControl formControlName="ownerVetDetails" id="ownerVetDetails" rows="2"></textarea>
                    </c-col>
                  </c-row>

                  <!-- Referral Source -->
                  <div class="mt-3">
                    <label cLabel class="d-block mb-2">{{ "HOW_DID_YOU_HEAR" | translate: { branchName: selectedBranch.name} }}</label>
                    <div class="d-flex flex-wrap gap-2">
                      <c-form-check inline *ngFor="let source of ['Facebook', 'Website', 'Friends', 'Relatives', 'Others']">
                        <input cFormCheckInput formControlName="howDidYouHearAboutGoodDog" [id]="source" type="radio" [value]="source" />
                        <label cFormCheckLabel [for]="source">{{ (source === 'Others' ? "OTHERS" : source) | translate }}</label>
                      </c-form-check>
                    </div>
                    <input *ngIf="selectedReferral === 'Others'" cFormControl class="mt-2" formControlName="howDidYouHearAboutGoodDogOther" placeholder="{{ 'OTHER' | translate }}" />
                  </div>
                </c-card-body>
              </c-card>

              <!-- 3. Pick Up Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold">{{ "PICKUP.HEADER" | translate }}</c-card-header>
                <c-card-body>
                  <label cLabel class="d-block mb-2">{{ "PICKUP.DO_YOU_NEED_PICKUP_SERVICE" | translate }}</label>
                  <div class="mb-3">
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isPickUpServiceNeeded" id="yesPick" type="radio" value="yes" />
                      <label cFormCheckLabel for="yesPick">Yes</label>
                    </c-form-check>
                    <c-form-check inline>
                      <input cFormCheckInput formControlName="isPickUpServiceNeeded" id="noPick" type="radio" value="no" />
                      <label cFormCheckLabel for="noPick">No</label>
                    </c-form-check>
                  </div>

                  <!-- Expanded Pickup Fields -->
                  <div *ngIf="isPickUpServiceNeededAnswer === 'yes'" class="p-3 bg-light rounded border">
                    <c-row class="mb-3">
                      <c-col md="6" class="mb-3 mb-md-0">
                        <label cLabel for="pFN">{{ "FIRST_NAME" | translate }}</label>
                        <input cFormControl formControlName="pickUpFirstName" id="pFN" />
                      </c-col>
                      <c-col md="6">
                        <label cLabel for="pLN">{{ "LAST_NAME" | translate }}</label>
                        <input cFormControl formControlName="pickUpLastName" id="pLN" />
                      </c-col>
                    </c-row>
                    <c-row>
                      <c-col md="4" class="mb-3">
                        <label cLabel for="pPh">{{ "PHONE" | translate }}</label>
                        <input cFormControl formControlName="pickUpPhone" id="pPh" />
                      </c-col>
                      <c-col md="4" class="mb-3">
                        <label cLabel for="pDate">{{ "DATE" | translate }}</label>
                        <input cFormControl formControlName="pickUpDate" id="pDate" type="date" />
                      </c-col>
                      <c-col md="4" class="mb-3">
                        <label cLabel for="pTime">{{ "TIME" | translate }}</label>
                        <input cFormControl formControlName="pickUpTime" id="pTime" type="time" />
                      </c-col>
                      <c-col xs="12">
                        <label cLabel for="pAdd">{{ "ADDRESS" | translate }}</label>
                        <input cFormControl formControlName="pickUpAddress" id="pAdd" />
                      </c-col>
                    </c-row>
                  </div>
                </c-card-body>
              </c-card>

              <!-- 4. Pet List Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold d-flex justify-content-between align-items-center">
                  {{ "PETS_LIST" | translate }}
                  <button type="button" cButton color="primary" size="sm" (click)="showNewPetModal()">
                    <i class="fas fa-plus me-1"></i> Add Pet
                  </button>
                </c-card-header>
                <c-card-body>
                  <c-row>
                    <c-col xs="12" md="6" lg="4" *ngFor="let pet of petsList; let i = index">
                      <c-card class="mb-3 shadow-sm" (click)="showPetDetailModal(i)" style="cursor: pointer;">
                        <c-card-body class="p-3">
                          <h6 class="fw-bold mb-1 text-primary">{{ pet.name }}</h6>
                          <div class="small text-muted">
                            Sex: {{ pet.sex }} | Age: {{ pet.age }}
                          </div>
                        </c-card-body>
                      </c-card>
                    </c-col>
                    <c-col xs="12" *ngIf="petsList.length === 0" class="text-center py-4 text-muted">
                      <p>No pets added yet. Please click "Add Pet".</p>
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>

              <!-- 5. Disclaimer Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold">{{ "DISCLAIMERS.HEADER" | translate }}</c-card-header>
                <c-card-body>
                  <div class="disclaimer-text mb-3 small" style="max-height: 250px; overflow-y: auto; background: #fdfdfd; padding: 10px; border: 1px solid #eee;">
                    <p>{{ "DISCLAIMERS.P1" | translate: { branchName: selectedBranch.name} }}</p>
                    <p>{{ "DISCLAIMERS.P2" | translate }}</p>
                    <p>{{ "DISCLAIMERS.P3" | translate }}</p>
                    <p>
                      <strong>{{ "DISCLAIMERS.IMPORTANT_POLICY.HEADER" | translate }}</strong>
                      <br /><span>{{ "DISCLAIMERS.IMPORTANT_POLICY.P1" | translate }}</span>
                    </p>
                    <!-- <p>{{ "DISCLAIMERS.IMPORTANT_POLICY.P1" | translate }}</p> -->
                    <div>
                      <strong>{{ "DISCLAIMERS.IMPORTANT_POLICY.HEALTH_REPORTING_TIMELINE_HEADER" | translate }}</strong>
                      <ul>
                        <li>{{ "DISCLAIMERS.IMPORTANT_POLICY.HEALTH_REPORTING_TIMELINE_1" | translate }}</li>
                        <li>{{ "DISCLAIMERS.IMPORTANT_POLICY.HEALTH_REPORTING_TIMELINE_2" | translate }}</li>
                      </ul>
                    </div>
                    <p>
                      <strong>{{ "DISCLAIMERS.IMPORTANT_POLICY.VETERINARY_DOCUMENTATION_REQUIRED_HEADER" | translate }}</strong>
                      <br /><span>{{ "DISCLAIMERS.IMPORTANT_POLICY.VETERINARY_DOCUMENTATION_REQUIRED_TEXT" | translate }}</span>
                    </p>
                    <p>
                      <strong>{{ "DISCLAIMERS.IMPORTANT_POLICY.HYGIENE_COMMITMENT_HEADER" | translate }}</strong>
                      <br /><span>{{ "DISCLAIMERS.IMPORTANT_POLICY.HYGIENE_COMMITMENT_TEXT" | translate }}</span>
                    </p>
                    <p>
                      <strong>{{ "DISCLAIMERS.IMPORTANT_POLICY.DOGS_BEING_DOGS_HEADER" | translate }}</strong>
                      <br /><span>{{ "DISCLAIMERS.IMPORTANT_POLICY.DOGS_BEING_DOGS_TEXT" | translate }}</span>
                    </p>
                    <p>{{ "DISCLAIMERS.IMPORTANT_POLICY.THANK_YOU" | translate }}</p>
                  </div>
                  <c-form-check>
                    <input cFormCheckInput formControlName="disclaimerAgreement" id="disAgree" type="checkbox" />
                    <label cFormCheckLabel for="disAgree" class="fw-bold">{{ "DISCLAIMERS.I_AGREE" | translate }}</label>
                  </c-form-check>
                </c-card-body>
              </c-card>

              <!-- 6. General Info Section -->
              <c-card class="mb-4 border-light shadow-sm">
                <c-card-header class="bg-white fw-bold">{{ "GENERAL_INFORMATION" | translate }}</c-card-header>
                <c-card-body class="small text-muted">
                  <ol class="ps-3">
                    <li class="mb-2"><strong>{{ "CHECK_IN_CHECK_OUT" | translate }}</strong>: {{ "CHECK_IN_CHECK_OUT_DESCRIPTION" | translate }}</li>
                    <li class="mb-2">{{ "CLOSE_TIME" | translate }}</li>
                    <li>{{ "REQUEST_DEPOSIT" | translate }}</li>
                  </ol>
                </c-card-body>
              </c-card>

              <!-- Submit Action -->
              <div class="d-grid mt-4">
                <button
                  cButton
                  color="primary"
                  size="lg"
                  type="submit"
                  [disabled]="!petRegisterForm.get('disclaimerAgreement')?.value || isRegisteringPet"
                >
                  <c-spinner *ngIf="isRegisteringPet" size="sm" class="me-2"></c-spinner>
                  {{ (isRegisteringPet ? "SUBMITTING" : "SUBMIT") | translate }}
                </button>
              </div>

            </form>
          </c-card-body>
        </c-card>

      </c-col>
    </c-row>
  </c-container>
</div>
